import React, { useEffect, useState } from 'react'

import { Button, CircularProgress, Icons } from 'components/Antifraude'
import validateStageOnboarding from 'utils/validateStage'
import { useSelector } from 'react-redux'
import { roles } from 'utils/constants/roles'
import { FailContainer } from './styles'

export default (props) => {
  const { history, location } = props
  const locationState = location.state
  const [loading, setLoading] = useState(false)
  const { token } = useSelector((state) => state.token)
  
  const handleLoading = (newState) => {
    setLoading(newState)
  }

  useEffect(() => {
    validateStageOnboarding(token, history, roles.DOCUMENT_OCR, handleLoading)
  }, [])

  function handleRetry() {
    if (locationState && locationState.type) {
      history.replace({
        pathname: '/ocr-upload',
        state: { type: locationState.type },
      })
    } else {
      history.replace('/ocr')
    }
  }

  return loading ? (
    <div className="loading">
      <div
        className="loading__container"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <CircularProgress style={{ textAlign: 'center' }} />
      </div>
    </div>
  ) : (
    <FailContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <h1>FALHA NA LEITURA DO DOCUMENTO</h1>
      <h4>Tente novamente, atentando-se às instruções:</h4>

      <table className="tip">
        <tbody>
          <tr>
            <td>
              <Icons icon="info" />
            </td>
            <td>
              Utilize um <u>documento recente</u>, bem preservado, sem borrões,
              rasgões, riscos ou partes amassadas.
            </td>
          </tr>
          <tr>
            <td>
              <Icons icon="info" />
            </td>
            <td>
              Coloque o documento sem a capinha (caso tenha) sobre uma
              superfície plana.
            </td>
          </tr>
          <tr>
            <td>
              <Icons icon="info" />
            </td>
            <td>
              Não tire fotos contra a luz direta para evitar manchas de
              reflexos.
            </td>
          </tr>
          <tr>
            <td>
              <Icons icon="info" />
            </td>
            <td>Enquadre seu documento totalmente na foto.</td>
          </tr>
          <tr>
            <td>
              <Icons icon="info" />
            </td>
            <td>Envie uma foto nítida, evite fotos tremidas ou borradas.</td>
          </tr>
        </tbody>
      </table>

      <Button onClick={handleRetry}>
        Tentar novamente
      </Button>
    </FailContainer>
  )
}
